import { spinningLogo } from '../components/spinning-logo';

spinningLogo('.spinning-icon');
